import { render } from "./SideMenu.vue?vue&type=template&id=0c224de8&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=0c224de8&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/maider/maider/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c224de8"]])

export default __exports__